<template>
  <div>
    <footer class="ht-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-3 col-sm-12 col-xs-12">
            <div class="ft-contact ft-infor1">
              <div class="ft-heading">
                <h6>{{ $t("navBar.about") }}</h6>
              </div>
              <div class="ct-it">
                <div style="text-align:left; color: #888888;">
                  <p class="text-justify" v-html="aboutUs"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12 col-xs-12">
            <div class="ft-infor ft-infor1">
              <div class="ft-heading">
                <h6>Afrik Eveil SITEMAP</h6>
              </div>
              <div class="infor-it">
                <ul class="left">
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a
                      :href="`/${$i18n.locale}/${this.$i18n.t('routes.home')}`"
                    >{{ $t("navBar.home") }}</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a
                      :href="
                        `/${$i18n.locale}/${this.$i18n.t('routes.howWeWork')}`
                      "
                    >{{ $t("navBar.howWeWork") }}</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a
                      :href="
                        `/${$i18n.locale}/${this.$i18n.t(
                          'routes.ourOrganization'
                        )}`
                      "
                    >{{ $t("navBar.ourOrganization") }}</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a
                      :href="
                        `/${$i18n.locale}/${this.$i18n.t('routes.ourHistory')}`
                      "
                    >{{ $t("navBar.ourHistory") }}</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a
                      :href="
                        `/${$i18n.locale}/${this.$i18n.t('routes.ourTeam')}`
                      "
                    >{{ $t("navBar.ourTeam") }}</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a :href="`/${$i18n.locale}/ghana-hub`">GHANA HUB</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a
                      :href="
                        `/${$i18n.locale}/${this.$i18n.t('routes.ourNews')}`
                      "
                    >{{ $t("navBar.ourNews") }}</a>
                  </li>
                </ul>
                <ul class="left">
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a
                      :href="
                        `/${$i18n.locale}/${this.$i18n.t('routes.ourBlogs')}`
                      "
                    >{{ $t("navBar.ourBlogs") }}</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a
                      :href="
                        `/${$i18n.locale}/${this.$i18n.t('routes.joinUs')}`
                      "
                    >{{ $t("navBar.joinUs") }}</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a
                      :href="`/${$i18n.locale}/${this.$i18n.t('routes.don')}`"
                    >{{ $t("navBar.don") }}</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a href="#">{{ $t("navBar.ourProjects") }}</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a
                      :href="
                        `/${$i18n.locale}/${this.$i18n.t('routes.contact')}`
                      "
                    >Contact</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a
                      :href="
                        `/${$i18n.locale}/${this.$i18n.t(
                          'routes.ourRessources'
                        )}`
                      "
                    >{{ $t("navBar.ourRessources") }}</a>
                  </li>
                  <li>
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                    <a
                      :href="
                        `/${$i18n.locale}/${this.$i18n.t('routes.discours')}`
                      "
                    >{{ $t("navBar.discours") }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-12 col-xs-12">
            <div class="ft-contact ft-infor1">
              <div class="ft-heading">
                <h6>{{ $t("navBar.ourContacts") }}</h6>
              </div>
              <ul class="ct-it">
                <li>
                  <i class="fa fa-map-marker" aria-hidden="true"></i>
                  <a href="#">{{ addresse }}</a>
                </li>
                <br />
                <li>
                  <i class="fa fa-envelope" aria-hidden="true"></i>
                  <a href="#">{{ contact_emailFr }}</a>
                </li>
                <br />
                <li>
                  <i class="fa fa-phone"></i>
                  <a href="#">{{ phone }}</a>
                </li>
              </ul>
              <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                  <ul class="ct-it">
                    <li>
                      <i class="fa fa-facebook"></i>
                      <a :href="facebook" target="_blank">Facebook</a>
                    </li>
                    <li>
                      <i class="fa fa-twitter"></i>
                      <a :href="twitter" target="_blank">Twitter</a>
                    </li>
                  </ul>
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                  <ul class="ct-it">
                    <li>
                      <i class="fa fa-linkedin"></i>
                      <a
                        href="https://www.linkedin.com/company/afrik-eveil/"
                        target="_blank"
                      >Linkedin</a>
                    </li>
                    <li>
                      <i class="fa fa-youtube"></i>
                      <a :href="youtube" target="_blank">Youtube</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div class="ft-below">
      <div class="container">
        <div class="row">
          <div class="col-md-12 col-sm-12 col-xs-12">
            <div class="ft-below-left">
              <center>
                <p>
                  {{ copyright }} {{ $t("by") }}
                  <a
                    class="readmore2"
                    href="https://yanfoma.tech"
                    target="_blank"
                  >Yanfoma</a>.
                </p>
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import APPURL from "../constant";
export default {
  watch: {
    $route() {
      this.getInfo();
    }
  },
  mounted() {
    this.getInfo();
  },
  computed: {
    addresse() {
      if (this.info[0]) {
        if (this.info[0].addresse) {
          return this.info[0].addresse;
        }
      }
      return "";
    },
    aboutUs() {
      if (this.info[0]) {
        if (this.info[0].aboutFr) {
          return this.info[0].aboutFr;
        } else {
          return this.info[0].aboutUs;
        }
      }
      return "";
    },
    copyright() {
      if (this.info[0]) {
        if (this.info[0].copyrightFr) {
          return this.info[0].copyrightFr;
        } else {
          return this.info[0].copyrightEn;
        }
      }
      return "";
    },
    contact_emailFr() {
      if (this.info[0]) {
        if (this.info[0].contact_emailFr) {
          return this.info[0].contact_emailFr;
        } else {
          return this.info[0].contact_emailEn;
        }
      }
      return "";
    },
    phone() {
      if (this.info[0]) {
        if (this.info[0].contact_numberFr) {
          return this.info[0].contact_numberFr;
        } else {
          return this.info[0].contact_numberEn;
        }
      }
      return "";
    },
    facebook() {
      if (this.info[0]) {
        return this.info[0].facebook;
      }
      return "";
    },
    twitter() {
      if (this.info[0]) {
        return this.info[0].twitter;
      }
      return "";
    },
    youtube() {
      if (this.info[0]) {
        return this.info[0].youtube;
      }
      return "";
    }
  },
  data() {
    return {
      info: {}
    };
  },
  methods: {
    getInfo(url = APPURL.LINK + "settings/" + this.$i18n.locale) {
      Axios.get(url).then(response => {
        this.info = response.data.data.results;
        //console.log(this.info[0]);
      });
    }
  },
  name: "Footer"
};
</script>
<style scoped lang="scss">
.ft-below-left a {
  color: #5bbb2d;
  font-weight: bold;
}

footer.ht-footer {
  background-color: #232323;
  background-position: center;
  padding: 90px 0 50px 0;
  background-size: cover;
  border-bottom: 2px solid #232323;
}

footer.ht-footer .ft-heading h6 {
  font-family: "Poppins", sans-serif;
  font-size: 18px;
  color: #5bbb2d;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 40px;
  text-align: center;
  margin-left: -80px;
}

footer.ht-footer ul {
  list-style: none;
  margin-left: 0;
}

footer.ht-footer ul li {
  margin-bottom: 15px;
  text-transform: capitalize;
}

footer.ht-footer ul li a {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #ababab;
  font-weight: 400;
  text-transform: "";
}

footer.ht-footer ul li:hover a {
  color: #5bbc2e;
  text-decoration: none;
}

footer.ht-footer .ft-contact ul.ct-it li i {
  font-size: 16px;
  margin-right: 20px;
  color: #ababab;
}

.ft-infor1 {
  margin-bottom: 30px;
}

footer.ht-footer .ft-infor .infor-it {
  display: flex;
}

footer.ht-footer .ft-infor .infor-it ul.left {
  margin-right: 20px;
  margin-left: 30px;
}

footer.ht-footer .ft-infor .infor-it ul.left i {
  font-size: 16px;
  margin-right: 10px;
  color: #ababab;
}

footer.ht-footer .ft-account .acc-it li {
  color: #ababab;
}

footer.ht-footer .ft-account .acc-it li span {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #ababab;
  font-weight: 400;
  text-transform: "";
}

footer.ht-footer .photo-it {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

footer.ht-footer .photo-it .img-ft {
  position: relative;
}

footer.ht-footer .photo-it .img-ft img {
  margin-bottom: 12px;
  margin-right: 12px;
  width: 73px;
  height: 73px;
  position: relative;
}

footer.ht-footer .photo-it .hover-inner-ft {
  position: absolute;
  width: 87%;
  height: 87%;
  top: 0;
  left: 0;
  content: "";
  background-color: #5bbc2e;
  opacity: 0;
  text-align: center;
  transition: all 0.5s;
}

footer.ht-footer .photo-it .hover-inner-ft .icon {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

footer.ht-footer .photo-it .hover-inner-ft a,
footer.ht-footer .photo-it .hover-inner-ft i {
  font-size: 14px;
  color: #f9f9f9;
  text-decoration: none;
}

footer.ht-footer .photo-it .img-ft:hover .hover-inner-ft {
  opacity: 0.9;
  transition: all 0.5s;
}

.ft-below {
  background-color: #191919;
  padding: 30px 0;
}

.ft-below .ft-below-left {
  margin-top: 10px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #ababab;
  font-weight: 400;
  text-transform: "";
}

.ft-below .ft-below-left i {
  color: #5bbc2e;
}

.ft-below .ft-below-right {
  float: right;
  right: 0;
  display: flex;
  margin-top: -40px;
}

.ft-below .ft-below-right p {
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #fff;
  font-weight: 400;
  text-transform: "";
  margin-right: 35px;
  margin-top: 5px;
}

.ft-below .ft-below-right a.ft-icon {
  background-size: cover;
  background-position: center;
  height: 55px;
  width: 55px;
  color: #5bbb2d;
  text-align: center;
  margin-right: 15px;
  margin-top: -12px;
}

.ft-below .ft-below-right a.ft-icon i {
  color: #f9f9f9;
  font-size: 24px;
  margin-top: 20px;
}

@media screen and (min-width: 1200px) and(max-width: 1670px) {
}

@media (min-width: 768px) and(max-width: 991px) {
  footer.ht-footer .ft-infor .infor-it {
    display: block;
  }

  footer.ht-footer .photo-it {
    margin-left: 20px;
  }
}

@media (max-width: 767px) {
  footer.ht-footer .ft-infor .infor-it {
    display: block;
  }

  .ft-below .ft-below-left {
    margin-bottom: 60px;
  }

  .ft-below .ft-below-right {
    float: left;
    left: 0;
    flex-wrap: wrap;
  }

  .ft-below .ft-below-right p {
    margin-right: 160px;
  }

  .ft-below .ft-below-right a.ft-icon {
    margin-right: 15px;
    margin-top: 0;
  }
}
/* .footer {
  background-color: #232323;
  background-position: center;
  padding: 90px 0 50px 0;
  background-size: cover;
  border-bottom: 2px solid #232323;
}

.copyright p {
  margin-top: 10px;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #ababab;
  font-weight: 400;
  padding: 10px;
}
.copyright a {
  color: #5bbb2d;
  font-weight: bold;
} */
</style>
